import { useMutation, useQueryClient } from "@tanstack/react-query";
import { returnAcceptedVerificationToDriver } from "../requests/return-to-driver.ts";
import { verifyKeys } from "../queries/keys.ts";
import type { ReturnToDriverRequest } from "../../types.ts";

// Mutation hook for returning accepted verification to driver
export const useReturnToDriverMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: ReturnToDriverRequest) => {
      const response = await returnAcceptedVerificationToDriver(data);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [...verifyKeys.all],
      });
    },
  });
};
